import {Route, Routes, Outlet, Navigate, useNavigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import {EmployeeListWrapper} from './bs-product-list/EmployeeList'
import {AddEmployee} from './bs-product-form'
import {EditProductWrapper} from './bs-product-form/EditProductWrapper'
import EditProduct from './bs-product-form/EditProduct'

const employeesBreadcrumbs: Array<PageLink> = [
  {
    title: 'Buy & Sell Product Management',
    path: '/bsProduct',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const BsProductPage = () => {
  const navigate = useNavigate()
  function goBack() {
    navigate(-1)
  }
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/list'
          element={
            <>
              <PageTitle breadcrumbs={employeesBreadcrumbs}>Buy & Sell Product list</PageTitle>
              <EmployeeListWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='list' />} />
      <Route
        path='/add'
        element={
          <>
            {' '}
            <PageTitle breadcrumbs={employeesBreadcrumbs}>Buy & Sell Product Add</PageTitle>
            <button
              onClick={goBack}
              style={{marginBottom: '15px'}}
              className='btn btn-sm btn-info px-6 align-self-center text-nowrap'
            >
              <i className='bi bi-reply fs-4 me-2'></i> Go Back{' '}
            </button>
            <AddEmployee />
          </>
        }
      />
      <Route
        path='/edit/:id'
        element={
          <>
            <PageTitle breadcrumbs={employeesBreadcrumbs}>Buy & Sell Product Edit</PageTitle>
            <button
              onClick={goBack}
              style={{marginBottom: '15px'}}
              className='btn btn-sm btn-info px-6 align-self-center text-nowrap'
            >
              <i className='bi bi-reply fs-4 me-2'></i> Go Back{' '}
            </button>
            <EditProductWrapper />
          </>
        }
      />
    </Routes>
  )
}

export default BsProductPage
